(ns dre.components.video-player
  {:authors ["Ondřej Nejedlý"]}
  (:require
   ["antd" :refer [Spin]]
   ["react-player/vimeo" :as ReactPlayer]
   [reagent.core :as r]
   [goog.string :as gstring]))

(defn player
  [id key & {:keys [player-conf vimeo-conf]}]
  (let [loaded? (r/atom false)]
    (fn [id key & {:keys [player-conf vimeo-conf]}]
      [:> Spin {:spinning (not @loaded?)}
       [:> ReactPlayer
        (cond->
         {:url (gstring/format "https://player.vimeo.com/video/%s?h=%s" id key)
          :controls true
          :config {:vimeo {:responsive true}}
          :onReady (fn [e] (reset! loaded? true))}
          player-conf
          (merge player-conf)
          vimeo-conf
          (update-in [:config :vimeo] merge vimeo-conf))]])))
